import { useState } from 'react';
import { Link, redirect, useNavigate } from 'react-router-dom';
import { InputTextblock, InputTextIcon, ButtonBlockPrimary } from '../../atoms';
import { FormGroup } from '../../moleculs';
import { signIn } from '../../../service/authService';
import { toast } from 'react-toastify';
import Cookies from 'js-cookie';
import { Base64 } from 'js-base64';

const FormAuth = () => {
    const [showPassword, setShowPassword] = useState<boolean>(false);
    const [username, setUsername] = useState("")
    const [password, setPassword] = useState("")

    const navigate = useNavigate();

    const onLogin = async () => {
        const data = {
            username,
            password
        }

        if (!username || !password) {
            toast.error("Email And Password is Required");
        } else {
            const response = await signIn(data);
            if (response.code > 300) {
                toast.error(response.message);
            } else {
                const { token } = response.data;
                const tokenBase64 = Base64.encode(token)
                Cookies.set("token", tokenBase64, { expires: 1 });
                toast.success(response.message);
                setTimeout(() => {
                    navigate("/admin", { replace: true });
                }, 1000)
            }
        }

    }

    return (
        <>
            <FormGroup label={'Email'}>
                <InputTextblock
                    value={username}
                    onChange={(e) => { setUsername(e.target.value) }}
                    placeholder='masukan alamat email anda' />
            </FormGroup>
            <FormGroup label={'Password'}>
                <InputTextIcon
                    placeholder='Password'
                    value={password}
                    onChange={(e) => { setPassword(e.target.value) }}
                    type={!showPassword ? 'password' : 'text'}
                    icon={!showPassword ? 'FaEyeSlash' : 'FaEye'}
                    onClick={() => { setShowPassword(!showPassword) }} />
            </FormGroup>
            <Link to={'/forget-password'}>
                <button className=" w-full flex justify-end text-danger text-[12px]">Lupa password?</button>
            </Link>
            <div className='my-8'>
                <ButtonBlockPrimary onClick={() => { onLogin() }} label='Login' />
            </div>
        </>
    );
};

export default FormAuth;